namespace app.model.exporting {
  export enum EndorsementType {
    None,
    Bates,
    Text,
    Tag
  }
}
